export default __webpack_public_path__ + "static/media/header_image.eb8f669e.png";